export const facilityType = {
  OUTDOOR: "Outdoor",
  INDOOR: "Indoor",
  GARAGE: "Garage",
  OFF_GRID: "Off-Grid",
  COMMERCIAL: "Commercial"
}